import { useContext } from "react";
import { AppChromeContext } from "./AppChromeContextDefinition";

export const useAppChrome = () => {
  const context = useContext(AppChromeContext);
  if (!context)
    throw new Error("useAppChrome must be used within AppChromeProvider");
  return context;
};
